export const modalStyle = {
    overlay : {
        zIndex: 2,
        backgroundColor   : 'rgba(0, 0, 0, 0.75)'
    },
    content: {
        top:'0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        padding: 0,
        background: 'transparent',
        border: 'none',
        overflow: 'visible',
        outline: 'none',
    }
};


// WEBPACK FOOTER //
// ./src/configs.js